import Vue from 'vue'
import Router from 'vue-router'
import Mypools from '@/components/Mypools/index'
import Pool from '@/components/Mypools/Pool'
import MypoolsCreate from '@/components/Mypools/Create'
import Profile from '@/components/Profile'
import Help from '@/components/Help/index'
import HelpVideos from '@/components/Help/HelpVideos'
import HelpVideo from '@/components/Help/HelpVideo'
import Instruction from '@/components/Help/Help'
import Questions from '@/components/Mypools/Questions'
import Support from '@/components/Support'
import Orders from '@/components/Orders'
import Lab from '@/components/Mypools/Lab'

import Auth from './auth'
import filter from './filter'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: { name: 'Mypools' }
        },
        {
            path: '/mypools',
            name: 'PoolsIndex',
            component: Mypools,
            props: true,
            children: [
                {
                    path: ':id',
                    name: 'Mypools',
                    component: Pool,
                    props: true
                },
                {
                    path: 'lab/:id',
                    name: 'Lab',
                    component: Lab,
                    props: true
                },
                {
                    path: '/questions/:id',
                    name: 'Questions',
                    component: Questions,
                    props: true
                }
            ]
        },
        {
            path: '/pools/create',
            name: 'MypoolsCreate',
            component: MypoolsCreate
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },

        {
            path: '/support',
            name: 'Support',
            component: Support
        },
        {
            path: '/help',
            component: Help,
            meta: {
                public: true
            },
            children: [
                {
                    path: '',
                    name: 'HelpVideos',
                    component: HelpVideos,
                    meta: {
                        public: true
                    }
                },
                {
                    path: ':id',
                    name: 'Instruction',
                    component: Instruction,
                    props: true,
                    meta: {
                        public: true
                    }
                }
            ]
        },
        {
            path: '/help/:id',
            name: 'HelpVideo',
            component: HelpVideo,
            props: true
        },
        {
            path: '/orders',
            name: 'Orders',
            component: Orders
        },
        Auth
    ]
})

router.beforeEach(filter)

export default router
